import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../constants/app-constants';
import { Router } from '@angular/router';
import { NeoUtilService } from '@bcone/neo-app-sdk';

@Component({
  selector: 'app-page-notfound',
  templateUrl: './page-notfound.component.html'
})
export class PageNotfoundComponent {
  commonConstant = AppConstants.COMMONCONSTANT;
  routerUrl: any;
  logsUrl: any;
  constructor(private router: Router,
    private neoUtilService:NeoUtilService) {
    if (neoUtilService.isValidAccessToken()) {
      this.routerUrl = router.url;
    } else {
      this.router.navigate(['/']);
    }
  }
}
